var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:tooltip",class:{
    '--inverted': _vm.inverted,
  },on:{"mouseenter":_vm.updateTipPlacement}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"ru:tooltip__text",class:_vm.placementClass},[_vm._v(_vm._s(_vm.tooltip))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }